import type { Data } from "@/types/data";

export function buildMedicalBusinessJsonLd(
	data: Data,
): Record<string, unknown> {
	const { cliente } = data;
	const address = cliente.endereco;
	const socialLinks = cliente["redes-sociais"]
		.filter((social) => social.ativa && social.url)
		.map((social) => social.url);

	return {
		"@context": "https://schema.org",
		"@type": "MedicalBusiness",
		name: cliente.nome,
		telephone: cliente.telefones[0]?.numero,
		email: cliente.email,
		address: {
			"@type": "PostalAddress",
			streetAddress: `${address.logradouro}, ${address.numero}`,
			addressLocality: address.cidade,
			addressRegion: address.estado,
			postalCode: address.cep,
			addressCountry: "BR",
		},
		sameAs: socialLinks,
		openingHours: cliente["horario-comercial"].map(
			(item) => `${item.dia} ${item.horario}`,
		),
	};
}
